package com.iregained.eventapp.components.sections.event_details.styles

import com.iregained.eventapp.theme.SitePalettes // IMPORT the static palette
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import org.jetbrains.compose.web.css.*
import com.varabyte.kobweb.compose.css.Transition

val RegistrationContainerStyle = CssStyle {
    // 1. Access the static palette instead of the @Composable ColorMode.current
    val palette = SitePalettes.light
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.gray)
            .styleModifier { property("scroll-margin-top", "100px") }
    }
}

val RegistrationCardStyle = CssStyle {
    val palette = SitePalettes.light
    base {
        Modifier
            .width(100.percent)
            .maxWidth(700.px)
            .backgroundColor(palette.custom.cardBackground)
            .borderRadius(12.px)
            .padding(2.cssRem)
            .boxShadow(0.px, 10.px, 30.px, color = rgba(0, 0, 0, 0.08))
            .border(1.px, LineStyle.Solid, palette.custom.neutralLight)
    }
}

val ModernInputStyle = CssStyle {
    val palette = SitePalettes.light
    base {
        Modifier
            .fillMaxWidth()
            .padding(12.px)
            .borderRadius(8.px)
            .backgroundColor(palette.custom.surfaceBackground)
            .border(1.px, LineStyle.Solid, palette.custom.divider)
            .color(palette.custom.darkText)
            .boxSizing(BoxSizing.BorderBox)
            .styleModifier { property("outline", "none") }
            .transition(Transition.of("border-color", 0.3.s))
    }
    focus {
        Modifier.border(1.px, LineStyle.Solid, palette.custom.brandPrimary)
    }
}